import React from 'react';
import { Box, BoxSection } from 'components/_new/Box';
import { Skeleton } from 'primereact/skeleton';

export const PairItemSkeleton = () => {
	return (
		<Box variant="white-bordered">
			<BoxSection>
				<div className="flex flex-row align-items-start gap-3 mb-4">
					<Skeleton shape="circle" size="4rem" />
					<div className="flex-1">
						<Skeleton width="60%" height="1.5rem" className="mb-2" />
						<Skeleton width="80%" height="1rem" />
					</div>
					<Skeleton width="120px" height="2rem" className="hidden sm:block" />
				</div>
				<div className="mb-4">
					<Skeleton width="40%" height="1rem" className="mb-2" />
					<div className="flex gap-2 flex-wrap">
						<Skeleton width="100px" height="2rem" borderRadius="1rem" />
						<Skeleton width="120px" height="2rem" borderRadius="1rem" />
						<Skeleton width="90px" height="2rem" borderRadius="1rem" />
						<Skeleton width="110px" height="2rem" borderRadius="1rem" />
					</div>
				</div>

				<div className="mb-4">
					<Skeleton width="35%" height="1rem" className="mb-2" />
					<Skeleton width="100%" height="1rem" className="mb-1" />
					<Skeleton width="100%" height="1rem" className="mb-1" />
					<Skeleton width="85%" height="1rem" />
				</div>

				<div className="flex justify-content-end">
					<Skeleton width="150px" height="2.5rem" borderRadius="0.5rem" />
				</div>
			</BoxSection>
		</Box>
	);
};
